import ResendModal from './resend-modal';

export default ResendModal;
